import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    disabled?: boolean;
  }>()
  .create(({ disabled, theme }) => ({
    inlineAutocomplete: {
      minWidth: 200,
      '.MuiOutlinedInput-root': {
        minHeight: 'unset'
      }
    },
    inlineAutocompleteContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.spacing(0.5)
    },
    inlineAutocompleteDisplayContainer: {
      alignItems: 'center',
      border: `1px solid transparent`,
      cursor: 'text',
      display: 'flex',
      gap: theme.spacing(1),
      justifyContent: 'space-between',
      marginLeft: theme.spacing(-0.5),
      paddingBottom: theme.spacing(0.25),
      paddingLeft: theme.spacing(0.5),
      paddingTop: theme.spacing(0.25),
      '&:hover': {
        borderColor: disabled ? 'none' : theme.vars.palette.divider
      },
      '&:hover .edit-icon': {
        opacity: 1
      }
    },
    inlineAutocompleteEditIcon: {
      marginLeft: theme.spacing(0.5),
      opacity: 0,
      transition: 'opacity 0.2s'
    }
  }));

export default useStyles;
